import { render, staticRenderFns } from "./openApp.vue?vue&type=template&id=192147c8&"
import script from "./openApp.vue?vue&type=script&lang=js&"
export * from "./openApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports